import { currencyFormatter } from "../../../helpers/currencyFormat";
import { formatDate, getDateYear } from "../../../helpers/formatDate";
import checkmarkIcon from "../../../assets/icons/circle_checkmark.svg";
import React, { useMemo, useState } from "react";
import "./dashboard_data.scss";
import isNil from "lodash/isNil";
import { Typography } from "@mui/material";
import { Image } from "../../../components/common";

const NewDashboard = ({ latestApplication, me, latestApplicationState }) => {
  const [activeTab, setActiveTab] = useState(0);

  const data = useMemo(() => [
    {
      label: "Personal information",
      items: [
        {
          label: "NAME",
          value: `${me?.firstname} ${me?.lastname}`,
        },
        {
          label: "E-mail",
          value: me?.email ? `${me?.email}` : "-",
        },
        {
          label: "Phone",
          value: `${me?.phone}`,
        },
        {
          label: "Birth Date",
          value: me?.birthDate ? `${formatDate(me?.birthDate)}` : "-",
        },
        {
          label: "Citizenship",
          value: latestApplication?.citizenshipStatus?.type ? `${latestApplication?.citizenshipStatus?.type}` : "-",
        },
        {
          label: "LinkedIn URL",
          value: me?.linkedinUrl ? `${me?.linkedinUrl}` : "-",
        },
        {
          label: "How did you hear about us?",
          value: me?.how ? `${me?.how}` : "-",
        },
      ]
    },
    {
      label: "Education",
      items: [
        {
          label: "INSTITUTION",
          value: latestApplication?.institution?.name ? `${latestApplication?.institution?.name}` : "-",
        },
        {
          label: "State",
          value: latestApplication?.state?.name ? `${latestApplication?.state?.name}` : "-",
        },
        {
          label: "Enrollment",
          value: latestApplication?.enrollmentStatus?.type ? `${latestApplication?.enrollmentStatus?.type}` : "-",
        },
        {
          label: "Degree",
          value: latestApplication?.degree?.type ? `${latestApplication?.degree?.type}` : "-",
        },
        {
          label: "School Year",
          value: latestApplication?.schoolYear?.type ? `${latestApplication?.schoolYear?.type}` : "-",
        },        
        {
          label: "Graduation",
          value: latestApplication?.graduation ? `${getDateYear(latestApplication?.graduation)}` : "-",
        },        
        {
          label: "Major",
          value: latestApplication?.major?.type ? `${latestApplication?.major?.type}` : "-",
        },        
        {
          label: "GPA",
          value: latestApplication?.gpa ? `${latestApplication?.gpa}` : "-",
        },      
      ]
    },
    {
      label: "Financial Details",
      items: [
        {
          label: "Requested amount",
          value: latestApplication?.amount ? `${currencyFormatter(latestApplication?.amount)}` : "-",
        },
        {
          label: "Pre-approved amount",
          value: latestApplication?.maxFundedAmount ? `${currencyFormatter(latestApplication?.maxFundedAmount)}` : "-",
        },
        {
          label: "Maximum number of years",
          value: "6",
        },
        {
          label: "Repayment cap",
          value: latestApplication?.maxFundedAmount ? `${currencyFormatter(1.9 * latestApplication?.maxFundedAmount)}` : "-",
        },
        {
          label: "Expected APR",
          value: latestApplication?.apr ? `${(Number(latestApplication?.apr) * 100).toFixed(2)}%` : "-",
        },
        {
          label: "Maximum APR",
          value: "18.90%",
        },
        {
          label: "Income Share",
          value: latestApplication?.maxFundedAmount ? `${((0.75 * latestApplication?.maxFundedAmount) / 1000).toFixed(2)}%` : "-",
        },
        {
          label: "Minimum Income Threshold",
          value: `${currencyFormatter(30000)}/year`,
        },
        {
          label: "Monthly Payment",
          value: `${currencyFormatter(latestApplication?.averageMonthlyPayment, 2)}`,
        },
        {
          label: "Total Costs",
          value: `${isNil(latestApplication?.totalCosts) ? "-" : currencyFormatter(latestApplication?.totalCosts)}`,
        },
      ]
    },
  ], [latestApplication, me]);

  return (
    <section className="dashboard-data-section">
      <div className="section__innerWrapper">
        <div className="dashboard-data-container">
          {data.map((item, index) => (
            <div className="dashboard-column" key={item.label} onClick={() => setActiveTab(index)}>
              <div className="column-title">
                {item.label}
              </div>
              <ul className={activeTab === index ? "open" : ""}>
                {item.items.map((item) => (
                  <li style={{ display: "flex", flexDirection: "column", gap: "5px" }} key={item.label}>
                    <Typography variant="label2">{item.label}</Typography>
                    <Typography variant="data">{item.value}</Typography>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="dashboard-bottom-row">
            <p>
              <Image src={checkmarkIcon} alt="Checkmark Icon" />
              You are all set! Thanks for applying.
              <br />
              Someone from our team will email you shortly.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewDashboard;
